import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { SystemUpdateAlt } from '@material-ui/icons';

import SquareLocationItem, { ISquareLocationItem } from './SquareLocationItem';

import SearchableChecklist from '../../yoello-lib/modules/components/UI/Lists/SearchableChecklist';
import { ISearchableChecklistItem } from '../../yoello-lib/modules/components/UI/Lists/SearchableChecklist/SearchableChecklistItem';
import LinearLoader from '../../yoello-lib/modules/components/UI/Loaders/LinearLoader';
import { useAPIV2 } from '../../yoello-lib/modules/API2/useAPIv2';
import { HTTPMethods } from '../../yoello-lib/modules/API/API';
import APIExtensions from '../../yoello-lib/modules/API2/APIDefs';

export const generateList = (locations: ISquareLocationItem[]) => {
    if(!locations) return [];

    return locations.map((location: ISquareLocationItem) => {
        const {errors, ...data} = location;
        const keywords = location.address ? [
            location.business_name,
            location.address?.address_line_1,
            location.address?.postal_code
        ].join(" ") : location.business_name;
        return {
            content: <SquareLocationItem {...location} />,
            selected: false,
            errors: location.errors,
            keywords,
            data: {...data}
        }
    })
}


export interface ISquareLocationImporterWidget {
    locations: ISearchableChecklistItem[];
    loading: boolean;
    error: boolean;
    onSuccess: (locations: ISquareLocationItem[]) => void;
}
 
const SquareLocationImporterWidget = (props: ISquareLocationImporterWidget) => {
    const { t } = useTranslation();
    const [ isImporting, setIsImporting ] = useState(false);

    const { callAPI : callVenuesAPI, isError: isVenueError } = useAPIV2(APIExtensions.createVenues, {
        onMountDisabled: true
    })

    const createVenues = async (items: ISearchableChecklistItem[]) => {
        setIsImporting(true);
        const response = await callVenuesAPI(HTTPMethods.POST, {
            //@ts-ignore
            body: {locations: items.map(venue => venue.data)}
        });
        if(response.isSuccessful){
            //@ts-ignore
            props.onSuccess(response.data.venues);
        }
        setIsImporting(false);
    }

    return (
        <div style={{position:"relative"}}>
            {
                isImporting ? 
                    <LinearLoader 
                        title={t("signup.square.importing_locations")} 
                        icon={<SystemUpdateAlt />}
                    /> :
                <SearchableChecklist 
                    items={props.locations}
                    description={t("signup.square.select_locations_description")}
                    loading={props.loading}
                    error={props.error || isVenueError}
                    searchName="locations"
                    submitText={t("signup.square.confirm_selection")}
                    onSubmit={createVenues}
                    errorMessage={t("signup.square.error")}
                    noDataMessage={t("signup.square.no_data")}
                />
            }
        </div>
    )

}

export default SquareLocationImporterWidget;